<template>
<div>
<div v-if="isLoading" class="loading">Loading&#8230;</div> 


<div class="columns is-multiline is-gapless ">
<div class="column is-12">
<div class="columns has-text-weight-bold has-text-light is-gapless has-background-light">
<div class="column is-4 borderIt isLabel mt-4 ml-2">Description</div>
<div class="column is-2 mt-2">
        <button @click="classrooms_new()" class="button is-fullwidth has-background-white has-text-success is-small">
            <span class="icon"><i class="fas fa-plus"></i></span>     
        </button> 
</div>
<div class="column is-2 borderIt isLabel has-text-centered mt-4 ">&nbsp;&nbsp;</div>

 <!-- FEE SAVE  -->
    <div class="column has-text-centered is-4 mt-2 has-text-weight-bold is-size-6" style=""> 
      <button @click="classrooms_save_sort(index)" class="button is-success is-fullwidth is-small"><span class="icon is-small has-text-white"> <i class="fas fa-save"></i> </span>&nbsp;&nbsp;&nbsp;SAVE</button>
    </div>

</div></div>

<div class="column is-12">
<div class="columns is-gapless has-background-light is-multiline is-centered is-vcentered colBorderThin" v-for="(data, index) in data_rooms" :key="index" style="margin-bottom:0em;">
<div class="column is-6 colNotes" style="border-right:1px solid gray;">
    <input v-model="data_rooms[index].schedRoom_DESC" placeholder="Desc" class="input is-fullwidth">
</div>
<!-- <div class="column is-2"> 
    <input @keyup="data_fees[index].isChanged = true" v-model="data_fees[index].progFee_AMT" type="number" placeholder="Desc" class="input has-text-right is-fullwidth">
</div> -->


 
 <!-- FEE DELETE  -->
<div @keyup.tab="classrooms_new()" class="column is-4 has-text-centered">
        <button @click="classrooms_delete_confirm(index)" class="button is-fullwidth has-text-danger"><span class="icon is-small has-text-danger"> <i class="fas fa-trash-alt"></i> </span></button>
</div>

</div></div>
</div>




  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: '',
  props: [ '' ],

    data() {
        return {
            isLoading:false,
            data_rooms:[],
        }
    },
 
mounted() {

    //GET FEES
    this.load_classrooms()

}, // END MOUNTED

methods: {

load_classrooms:function() {  //GET FEES
    this.isLoading=true;
    // GET PROGRAMS
    var sql = "SELECT * FROM myMEQ_SCHEDULE_ROOM ORDER BY schedRoom_DESC"
    axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(sql))
    .then(res => { 
        this.data_rooms = res.data
        this.isLoading=false;  
      })
},


classrooms_new:function() {
    if(this.data_rooms.length > 0) 
    {this.data_rooms.push({schedRoom_ID:0 , schedRoom_DESC:''})}
    else {this.data_rooms.push({schedRoom_ID:0 , schedRoom_DESC:'' })}
}, // END FEE ADD

classrooms_delete_confirm:function(index) {

    this.$snotify.html(`<div class="snotifyToast__title"><b>Delete Fee?</b></div>
  <div class="snotifyToast__body">`+ this.data_rooms[index].schedRoom_DESC +`</div> ` , {
    timeout: 20000, showProgressBar: true, closeOnClick: false, pauseOnHover: true,position:"centerCenter", type:'error',
        buttons: [
            {text: 'Ok', action: (toast) => this.classrooms_delete_do(toast,index), bold: true},
            {text: 'Cancel', action: (toast) => {this.$snotify.remove(toast.id); }, bold: true},
        ]
    });


},
classrooms_delete_do:function(toast,index) {
    this.$snotify.remove(toast.id);
// CHECK IF NOT SAVED
    if (this.data_rooms[index].schedRoom_ID == 0 ) 
    {this.data_rooms.splice(index,1) ; return}

// SAVED -- REMOVE FROM DB
    var sql = "DELETE FROM myMEQ_SCHEDULE_ROOM WHERE schedRoom_ID = " + this.data_rooms[index].schedRoom_ID
    axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(sql))
    .then(res => { 
        this.data_rooms.splice(index,1)
        this.$snotify.success('DELETED!!' , {timeout: 1000,showProgressBar: true,closeOnClick: true,pauseOnHover: true,position: "rightBottom",});
    });


},


classrooms_save_sort:function() {
//CHECK IF INSERT/UPDATE
this.isLoading = true;

var query = ''
for (var i = 0; i < this.data_rooms.length; i++) {
if (this.data_rooms[i].schedRoom_DESC.trim() != '') {
    if (this.data_rooms[i].schedRoom_ID != 0) {
        query += "UPDATE myMEQ_SCHEDULE_ROOM SET schedRoom_DESC = '" + this.data_rooms[i].schedRoom_DESC.replace(/'/g,"''") + "' WHERE schedRoom_ID = " + this.data_rooms[i].schedRoom_ID
        query += ` ; `
    } else {
        query += "INSERT INTO myMEQ_SCHEDULE_ROOM (schedRoom_DESC) VALUES ('" + this.data_rooms[i].schedRoom_DESC.replace(/'/g,"''") + "')"       
        query += ` ; `
    }
} }// END FOR  / IF NOT BLANC

// console.log(query)

    let formData = new FormData();
    formData.append('query', encodeURIComponent(query));
    axios({
        method: 'post',
        url: this.$url+sessionStorage.getItem('url_query_form'),
        data: {
            query:encodeURIComponent(query)
        },
    })
    .then(res => {
        this.isLoading = false;
    })

}, // END SAVE 




},





} // END EXPORT
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
